import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationToHourMin'
})
export class DurationToHourMinPipe implements PipeTransform {

  transform(value: string): any {
    let duration = value.split(':');
    let hours = +duration[0] ;
    let minutes =  +duration[1];
    return hours + 'h ' + minutes + 'm';
  }

}
